import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpBackend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
  .use(HttpBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'fr',
    supportedLngs: ['fr', 'de', 'it', 'en'],
    defaultNS: 'common',
    ns: [
      'common',
      'estimation',
      'demographics',
      'plq',
      'subsidies',
      'amortization',
      'planning',
      'population',
      'finances',
      'export',
      'report',
      'admin',
      'nav',
      'dashboard',
      'activity',
      'actuals',
      'map',
      'comparison',
      'workflow',
      'benchmark',
      'simulation',
      'stress',
      'consult',
      'ai',
      'optimizer',
      'import',
      'guide',
      'admin_mod',
      'finance_mod',
      'spatial',
      'comments',
      'landing',
    ],
    backend: {
      // Cache-bust locale files per build so translation edits ship immediately
      // instead of hiding behind the browser's 1-hour HTTP cache on /locales/*.json.
      // __BUILD_ID__ is a Vite `define` set to Date.now() at build time.
      loadPath: `/locales/{{lng}}/{{ns}}.json?v=${__BUILD_ID__}`,
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
